import { all, put, call, takeEvery } from 'redux-saga/effects'
import { getLeftMenuData, getTopMenuData, getLoginUserType } from 'services/menu'
import _ from 'underscore'
// import dataConstant from 'constants/dataConstants';
import actions from './actions'

export function* GET_DATA() {
  const LoginstateData = yield call(getLoginUserType)
  let menuTopData = null
  const menuLeftData = yield call(getLeftMenuData)

  if (LoginstateData != null) {
    // Filter menu list, which  which are not type of login RefType.
    menuTopData = _.filter(yield call(getTopMenuData), item => {
      return item.type === LoginstateData.RefType
    })
    if (menuTopData && menuTopData.length > 0) {
      // Exclude sub-menus which are not type of login RefType.
    }
  } else {
    menuTopData = [] // yield call(getTopMenuData)
  }
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuLeftData,
      menuTopData,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_DATA, GET_DATA),
    GET_DATA(),
    // run once on app load to fetch menu data
  ])
}
